import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ element, isAuthenticated }) => {

    
    // console.log(element, "element log")
    //   Check if the user is authenticated 
    const isUserAuthenticated = isAuthenticated;
    // Replace this with your authentication logic // If the user is authenticated, render the protected component 
    if (isUserAuthenticated) { return element; } // If the user is not authenticated, redirect to the login page or another route 
    return <Navigate to="/" />;
};

export default PrivateRoute;